import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("mdc_admin_token", data.token);
      toast.success("Bienvenue dans le back-office.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err, "Connexion impossible."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-cream px-5">
      <form data-testid="admin-login-form" onSubmit={submit} className="card-warm w-full max-w-sm space-y-5 p-8">
        <div>
          <img src="/logo.png" alt="La Maison de la Charité" className="h-16 w-auto" />
          <p className="mt-1 text-xs font-medium uppercase tracking-[0.2em] text-stone-500">Back-office</p>
        </div>
        <div>
          <label htmlFor="a-email" className="mb-1.5 block text-sm font-semibold text-obsidian">Email</label>
          <input id="a-email" data-testid="admin-email-input" type="email" required className="input-field"
            value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
        </div>
        <div>
          <label htmlFor="a-password" className="mb-1.5 block text-sm font-semibold text-obsidian">Mot de passe</label>
          <input id="a-password" data-testid="admin-password-input" type="password" required className="input-field"
            value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </div>
        <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
          <LogIn className="h-4 w-4" />
          {loading ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
